import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, FileText } from 'lucide-react';
export function TermsRestaurantsPage() {
  return <div className="min-h-screen bg-[#0B0B0B] text-white selection:bg-[#006847] selection:text-white" data-id="element-8187">
      {/* Header */}
      <header className="sticky top-0 z-50 bg-[#0B0B0B]/80 backdrop-blur-md border-b border-white/10" data-id="element-8188">
        <div className="max-w-4xl mx-auto px-6 h-16 flex items-center justify-between" data-id="element-8189">
          <Link to="/" className="flex items-center gap-2 text-white/60 hover:text-white transition-colors text-sm font-medium" data-id="element-8190">
            <ArrowLeft className="w-4 h-4" data-id="element-8191" />
            Volver
          </Link>
          <div className="font-black text-xl tracking-tight" data-id="element-8192">NOIZA</div>
          <div className="w-20" data-id="element-8193" /> {/* Spacer for centering */}
        </div>
      </header>

      {/* Content */}
      <main className="max-w-3xl mx-auto px-6 py-12 md:py-20" data-id="element-8194">
        <div className="mb-12" data-id="element-8195">
          <div className="w-12 h-12 bg-white/5 rounded-2xl flex items-center justify-center mb-6 border border-white/10" data-id="element-8196">
            <FileText className="w-6 h-6 text-white/80" data-id="element-8197" />
          </div>
          <h1 className="text-3xl md:text-4xl font-black mb-4 tracking-tight" data-id="element-8198">
            Términos y Condiciones para Restaurantes
          </h1>
          <p className="text-white/60 text-lg" data-id="element-8199">
            NOIZA – Plataforma Tecnológica y Marketplace Gastronómico
          </p>
        </div>

        <div className="space-y-12 text-white/80 leading-relaxed" data-id="element-8200">
          <section data-id="element-8201">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-8202">
              <span className="text-[#006847]" data-id="element-8203">1.</span>
              INTRODUCCIÓN Y ACEPTACIÓN
            </h2>
            <div className="space-y-4" data-id="element-8204">
              <p data-id="element-8205">
                Los presentes Términos y Condiciones regulan el acceso, uso y
                permanencia del restaurante dentro de la plataforma NOIZA, en
                adelante "la Plataforma".
              </p>
              <p data-id="element-8206">
                Al registrarse, acceder o utilizar cualquier funcionalidad de
                NOIZA, el restaurante declara:
              </p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-8207">
                <li data-id="element-8208">Haber leído íntegramente este documento</li>
                <li data-id="element-8209">Comprender su contenido en su totalidad</li>
                <li data-id="element-8210">
                  Aceptar voluntaria e irrevocablemente todas sus condiciones
                </li>
              </ul>
              <p data-id="element-8211">
                En caso de no estar de acuerdo con alguno de los puntos
                establecidos, el restaurante deberá abstenerse de utilizar la
                Plataforma.
              </p>
            </div>
          </section>

          <section data-id="element-8212">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-8213">
              <span className="text-[#006847]" data-id="element-8214">2.</span>
              NATURALEZA DEL SERVICIO
            </h2>
            <div className="space-y-4" data-id="element-8215">
              <p data-id="element-8216">NOIZA es una solución tecnológica que combina:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-8217">
                <li data-id="element-8218">Software como servicio (SaaS)</li>
                <li data-id="element-8219">Marketplace digital gastronómico</li>
                <li data-id="element-8220">Herramientas de gestión operativa para restaurantes</li>
              </ul>
              <p data-id="element-8221">La Plataforma permite a los restaurantes:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-8222">
                <li data-id="element-8223">Mostrar su menú digital</li>
                <li data-id="element-8224">Recibir pedidos de clientes</li>
                <li data-id="element-8225">Gestionar su operación interna</li>
                <li data-id="element-8226">
                  Facilitar la comunicación directa con el cliente
                  (principalmente vía WhatsApp)
                </li>
              </ul>
              <p className="font-medium text-white" data-id="element-8227">
                NOIZA actúa únicamente como un facilitador tecnológico.
              </p>
            </div>
          </section>

          <section data-id="element-8228">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-8229">
              <span className="text-[#006847]" data-id="element-8230">3.</span>
              DECLARACIÓN EXPRESA DE NO INTERMEDIACIÓN
            </h2>
            <div className="space-y-4" data-id="element-8231">
              <p data-id="element-8232">El restaurante reconoce expresamente que NOIZA:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-8233">
                <li data-id="element-8234">No es proveedor de alimentos</li>
                <li data-id="element-8235">No participa en la preparación de productos</li>
                <li data-id="element-8236">No manipula alimentos en ningún momento</li>
                <li data-id="element-8237">No realiza entregas ni logística</li>
                <li data-id="element-8238">No procesa pagos en nombre del restaurante</li>
                <li data-id="element-8239">No actúa como representante comercial del restaurante</li>
              </ul>
              <p data-id="element-8240">
                La Plataforma se limita a proporcionar herramientas digitales
                para facilitar la interacción entre el restaurante y el cliente
                final.
              </p>
            </div>
          </section>

          <section data-id="element-8241">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-8242">
              <span className="text-[#006847]" data-id="element-8243">4.</span>
              INDEPENDENCIA DEL RESTAURANTE
            </h2>
            <div className="space-y-4" data-id="element-8244">
              <p data-id="element-8245">
                Cada restaurante que utiliza NOIZA opera como una entidad
                completamente independiente.
              </p>
              <p data-id="element-8246">Esto implica que:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-8247">
                <li data-id="element-8248">El restaurante es el único responsable de su operación</li>
                <li data-id="element-8249">
                  No existe relación laboral, societaria o de representación con
                  NOIZA
                </li>
                <li data-id="element-8250">
                  NOIZA no ejerce control sobre las decisiones del restaurante
                </li>
              </ul>
              <p data-id="element-8251">El restaurante mantiene total autonomía en:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-8252">
                <li data-id="element-8253">Precios</li>
                <li data-id="element-8254">Menú</li>
                <li data-id="element-8255">Horarios</li>
                <li data-id="element-8256">Métodos de pago</li>
                <li data-id="element-8257">Procesos internos</li>
              </ul>
            </div>
          </section>

          <section data-id="element-8258">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-8259">
              <span className="text-[#006847]" data-id="element-8260">5.</span>
              EXCLUSIÓN TOTAL DE RESPONSABILIDAD
            </h2>

            <div className="space-y-8" data-id="element-8261">
              <div data-id="element-8262">
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-8263">
                  5.1. Alcance general
                </h3>
                <p data-id="element-8264">
                  El restaurante acepta que NOIZA queda exento de cualquier tipo
                  de responsabilidad, directa o indirecta, derivada de la
                  operación del restaurante.
                </p>
              </div>

              <div data-id="element-8265">
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-8266">
                  5.2. Alimentos y calidad del servicio
                </h3>
                <p className="mb-2" data-id="element-8267">NOIZA no será responsable por:</p>
                <ul className="list-disc pl-6 space-y-1 text-white/70 mb-2" data-id="element-8268">
                  <li data-id="element-8269">Calidad de los alimentos</li>
                  <li data-id="element-8270">Estado, frescura o preparación</li>
                  <li data-id="element-8271">Ingredientes utilizados</li>
                  <li data-id="element-8272">Contaminación cruzada</li>
                  <li data-id="element-8273">Problemas de higiene o salubridad</li>
                  <li data-id="element-8274">Reacciones alérgicas</li>
                </ul>
                <p className="font-medium text-white" data-id="element-8275">
                  Toda responsabilidad recae exclusivamente en el restaurante.
                </p>
              </div>

              <div data-id="element-8276">
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-8277">
                  5.3. Entregas y logística
                </h3>
                <p className="mb-2" data-id="element-8278">
                  NOIZA no participa ni interviene en la entrega de pedidos. Por
                  lo tanto, NOIZA no será responsable por:
                </p>
                <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-8279">
                  <li data-id="element-8280">Retrasos en la entrega</li>
                  <li data-id="element-8281">Pérdida de pedidos</li>
                  <li data-id="element-8282">Entregas incompletas</li>
                  <li data-id="element-8283">Errores en dirección</li>
                  <li data-id="element-8284">Conducta de repartidores</li>
                  <li data-id="element-8285">Daños durante el transporte</li>
                </ul>
              </div>

              <div data-id="element-8286">
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-8287">
                  5.4. Pagos
                </h3>
                <p className="mb-2" data-id="element-8288">
                  NOIZA no procesa ni administra pagos. El restaurante es el
                  único responsable de:
                </p>
                <ul className="list-disc pl-6 space-y-1 text-white/70 mb-4" data-id="element-8289">
                  <li data-id="element-8290">Recepción de pagos</li>
                  <li data-id="element-8291">Validación de transferencias (incluyendo SINPE)</li>
                  <li data-id="element-8292">Manejo de efectivo</li>
                  <li data-id="element-8293">Confirmación de pagos</li>
                  <li data-id="element-8294">Prevención de fraudes</li>
                </ul>
                <p className="mb-2" data-id="element-8295">NOIZA no será responsable por:</p>
                <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-8296">
                  <li data-id="element-8297">Pagos no recibidos</li>
                  <li data-id="element-8298">Comprobantes falsos</li>
                  <li data-id="element-8299">Errores en montos</li>
                  <li data-id="element-8300">Estafas o fraudes de terceros</li>
                </ul>
              </div>

              <div data-id="element-8301">
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-8302">
                  5.5. Relación con clientes
                </h3>
                <p className="mb-2" data-id="element-8303">NOIZA no será responsable por:</p>
                <ul className="list-disc pl-6 space-y-1 text-white/70 mb-2" data-id="element-8304">
                  <li data-id="element-8305">Reclamos de clientes</li>
                  <li data-id="element-8306">Reembolsos</li>
                  <li data-id="element-8307">Cancelaciones</li>
                  <li data-id="element-8308">Disputas</li>
                  <li data-id="element-8309">Opiniones o reseñas</li>
                </ul>
                <p className="font-medium text-white" data-id="element-8310">
                  Toda relación comercial se da directamente entre el
                  restaurante y el cliente.
                </p>
              </div>
            </div>
          </section>

          <section data-id="element-8311">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-8312">
              <span className="text-[#006847]" data-id="element-8313">6.</span>
              USO DE LA PLATAFORMA
            </h2>
            <div className="space-y-4" data-id="element-8314">
              <p data-id="element-8315">El restaurante se compromete a utilizar NOIZA de forma:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-8316">
                <li data-id="element-8317">Responsable</li>
                <li data-id="element-8318">Legal</li>
                <li data-id="element-8319">Transparente</li>
              </ul>
              <p className="mt-4" data-id="element-8320">Queda prohibido:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-8321">
                <li data-id="element-8322">Publicar información falsa</li>
                <li data-id="element-8323">Manipular precios de forma engañosa</li>
                <li data-id="element-8324">Simular disponibilidad inexistente</li>
                <li data-id="element-8325">Utilizar la plataforma con fines fraudulentos</li>
              </ul>
            </div>
          </section>

          <section data-id="element-8326">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-8327">
              <span className="text-[#006847]" data-id="element-8328">7.</span>
              PROPIEDAD DEL MENÚ DIGITAL
            </h2>
            <div className="space-y-4" data-id="element-8329">
              <p data-id="element-8330">El menú digital creado dentro de NOIZA:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-8331">
                <li data-id="element-8332">Pertenece al restaurante en términos de contenido</li>
                <li data-id="element-8333">
                  Puede ser utilizado por el restaurante fuera del marketplace
                </li>
              </ul>
              <p className="mt-4 font-medium text-white" data-id="element-8334">Condiciones:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-8335">
                <li data-id="element-8336">
                  Si el restaurante mantiene una suscripción activa, el sistema
                  opera normalmente
                </li>
                <li data-id="element-8337">
                  Si no mantiene suscripción:
                  <ul className="list-circle pl-6 mt-2 space-y-1" data-id="element-8338">
                    <li data-id="element-8339">
                      Podrá seguir utilizando el sistema únicamente si cubre
                      costos asociados (hosting, dominio, etc.)
                    </li>
                    <li data-id="element-8340">NOIZA podrá limitar funcionalidades</li>
                  </ul>
                </li>
              </ul>
            </div>
          </section>

          <section data-id="element-8341">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-8342">
              <span className="text-[#006847]" data-id="element-8343">8.</span>
              SISTEMA SaaS
            </h2>
            <div className="space-y-4" data-id="element-8344">
              <p data-id="element-8345">NOIZA proporciona un sistema tecnológico que incluye:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-8346">
                <li data-id="element-8347">Menú digital</li>
                <li data-id="element-8348">Gestión de pedidos</li>
                <li data-id="element-8349">Herramientas operativas</li>
              </ul>
              <div className="grid sm:grid-cols-2 gap-6 mt-6" data-id="element-8350">
                <div className="bg-white/5 p-4 rounded-xl border border-white/10" data-id="element-8351">
                  <p className="font-medium text-white mb-2" data-id="element-8352">
                    El restaurante recibe:
                  </p>
                  <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-8353">
                    <li data-id="element-8354">Derecho de uso del sistema</li>
                  </ul>
                </div>
                <div className="bg-white/5 p-4 rounded-xl border border-white/10" data-id="element-8355">
                  <p className="font-medium text-white mb-2" data-id="element-8356">NO recibe:</p>
                  <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-8357">
                    <li data-id="element-8358">Propiedad del software</li>
                    <li data-id="element-8359">Acceso al código fuente</li>
                  </ul>
                </div>
              </div>
              <p className="font-medium text-white mt-4" data-id="element-8360">
                NOIZA mantiene todos los derechos sobre la tecnología
                desarrollada.
              </p>
            </div>
          </section>

          <section data-id="element-8361">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-8362">
              <span className="text-[#006847]" data-id="element-8363">9.</span>
              DISPONIBILIDAD DEL SERVICIO
            </h2>
            <div className="space-y-4" data-id="element-8364">
              <p data-id="element-8365">NOIZA no garantiza:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-8366">
                <li data-id="element-8367">Disponibilidad continua</li>
                <li data-id="element-8368">Funcionamiento sin interrupciones</li>
                <li data-id="element-8369">Ausencia total de errores</li>
              </ul>
              <p className="mt-4" data-id="element-8370">Pueden ocurrir:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-8371">
                <li data-id="element-8372">Fallas técnicas</li>
                <li data-id="element-8373">Actualizaciones</li>
                <li data-id="element-8374">Mantenimientos</li>
              </ul>
              <p className="font-medium text-white mt-2" data-id="element-8375">
                NOIZA no será responsable por pérdidas derivadas de estos
                eventos.
              </p>
            </div>
          </section>

          <section data-id="element-8376">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-8377">
              <span className="text-[#006847]" data-id="element-8378">10.</span>
              VISIBILIDAD EN EL MARKETPLACE
            </h2>
            <div className="space-y-4" data-id="element-8379">
              <p data-id="element-8380">El restaurante acepta que su visibilidad dentro de NOIZA:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-8381">
                <li data-id="element-8382">No está garantizada permanentemente</li>
                <li data-id="element-8383">Puede variar según criterios internos</li>
              </ul>
              <p className="mt-4" data-id="element-8384">NOIZA podrá:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-8385">
                <li data-id="element-8386">Destacar o no restaurantes</li>
                <li data-id="element-8387">Modificar posiciones</li>
                <li data-id="element-8388">Aplicar filtros o algoritmos</li>
              </ul>
            </div>
          </section>

          <section data-id="element-8389">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-8390">
              <span className="text-[#006847]" data-id="element-8391">11.</span>
              PAGOS Y CONDICIONES ECONÓMICAS
            </h2>
            <div className="space-y-4" data-id="element-8392">
              <p data-id="element-8393">El restaurante se compromete a:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-8394">
                <li data-id="element-8395">Cumplir con los pagos acordados</li>
                <li data-id="element-8396">Mantener su cuenta al día</li>
              </ul>
              <p className="mt-4" data-id="element-8397">En caso de incumplimiento, NOIZA podrá:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-8398">
                <li data-id="element-8399">Suspender el servicio</li>
                <li data-id="element-8400">Limitar funcionalidades</li>
                <li data-id="element-8401">Retirar visibilidad</li>
              </ul>
            </div>
          </section>

          <section data-id="element-8402">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-8403">
              <span className="text-[#006847]" data-id="element-8404">12.</span>
              TERMINACIÓN
            </h2>
            <div className="space-y-4" data-id="element-8405">
              <p data-id="element-8406">NOIZA podrá suspender o terminar el acceso en caso de:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-8407">
                <li data-id="element-8408">Incumplimiento de términos</li>
                <li data-id="element-8409">Uso indebido</li>
                <li data-id="element-8410">Conductas que afecten la plataforma</li>
              </ul>
              <p className="mt-2" data-id="element-8411">
                El restaurante podrá dejar de usar el servicio en cualquier
                momento.
              </p>
            </div>
          </section>

          <section data-id="element-8412">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-8413">
              <span className="text-[#006847]" data-id="element-8414">13.</span>
              MODIFICACIONES
            </h2>
            <div className="space-y-4" data-id="element-8415">
              <p data-id="element-8416">NOIZA podrá modificar estos términos en cualquier momento.</p>
              <p data-id="element-8417">El uso continuo implica aceptación automática de cambios.</p>
            </div>
          </section>

          <section data-id="element-8418">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-8419">
              <span className="text-[#006847]" data-id="element-8420">14.</span>
              LIMITACIÓN DE RESPONSABILIDAD
            </h2>
            <div className="space-y-4" data-id="element-8421">
              <p data-id="element-8422">En ningún caso NOIZA será responsable por:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-8423">
                <li data-id="element-8424">Pérdidas económicas</li>
                <li data-id="element-8425">Daños indirectos</li>
                <li data-id="element-8426">Lucro cesante</li>
                <li data-id="element-8427">Daños reputacionales</li>
              </ul>
            </div>
          </section>

          <section data-id="element-8428">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-8429">
              <span className="text-[#006847]" data-id="element-8430">15.</span>
              LEGISLACIÓN APLICABLE
            </h2>
            <div className="space-y-4" data-id="element-8431">
              <p data-id="element-8432">
                Estos términos se regirán por la legislación aplicable en Costa
                Rica.
              </p>
            </div>
          </section>

          <section className="bg-white/5 p-6 rounded-2xl border border-white/10 mt-12" data-id="element-8433">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-8434">
              <span className="text-[#006847]" data-id="element-8435">16.</span>
              ACEPTACIÓN FINAL
            </h2>
            <div className="space-y-4" data-id="element-8436">
              <p className="font-medium" data-id="element-8437">El restaurante declara que:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/80" data-id="element-8438">
                <li data-id="element-8439">Ha leído este documento completo</li>
                <li data-id="element-8440">Comprende su alcance</li>
                <li data-id="element-8441">Acepta todas sus condiciones</li>
              </ul>
            </div>
          </section>
        </div>
      </main>
    </div>;
}